<div id="footer" class="row">
	<div class="col-3">
	  <a target="_blank" onclick="dataLayer.push({'event': 'iconClick', 'category': 'Member', 'action': 'Footer Icon - Facebook', 'label': 'Facebook Icon Click'})" href="https://www.facebook.com/KWSPMalaysia/">
		<img src="./assets/images/links_fb_icon_en.png" height="30px">
	  </a> 
	  <a target="_blank" onclick="dataLayer.push({'event': 'iconClick', 'category': 'Member', 'action': 'Footer Icon - Twitter', 'label': 'Twitter Icon Click'})" href="https://twitter.com/KWSPMalaysia">
		<img src="./assets/images/links_twitter_icon_en.png" height="30px">
	  </a>
	  <a target="_blank" onclick="dataLayer.push({'event': 'iconClick', 'category': 'Member', 'action': 'Footer Icon - LinkedIn', 'label': 'LinkedIn Icon Click'})" href="https://www.linkedin.com/company/epf-malaysia">
		<img src="./assets/images/links_linkedin_icon_en.png" height="30px">
	  </a>
	  <a target="_blank" onclick="dataLayer.push({'event': 'iconClick', 'category': 'Member', 'action': 'Footer Icon - Social Media', 'label': 'Social Media Icon Click'})" href="https://www.youtube.com/channel/UCkJXw7smZdbUSXb4DKR103w">
		<img src="./assets/images/links_youtube_icon_en.png" height="30px">
	  </a>
	</div>
	<div class="col-9">
		<p >{{ 'BestViewed' | translate }}</p>
		<p >{{ 'Copyright' | translate }}</p>
	</div>
</div>